import styles from './article-content.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { WArticle } from '../../components/prefabs/article/article';
import { WButton, WIconButton, WSnackbar } from '../../components/wrappers/wrapper';
import CloseIcon from '@mui/icons-material/Close';
import { TArticle, TChannel, TCategory } from '../../models/common';
import dbService from '../../services/database.service';
import { WSkeleton, WStack } from '../../components/wrappers/wrapper';
import useArticle from 'custom-hooks/useArticle';
import ArticleContentSidebar from '../../components/organisms/article-content-sidebar/article-content-sidebar';

export function ArticleContentPage() {
  const { article_id } = useParams();
  const { deleteArticle } = useArticle();

  const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);
  const [article, setArticle] = useState<TArticle>();
  const [loading, setLoading] = useState(true);
  const [hideInteractions, setHideInteractions] = useState(false);
  const [isDocumentation, setIsDocumentation] = useState(false);

  const navigate = useNavigate();
  const action = (
    <React.Fragment>
      <WButton
        variant="contained"
        size="small"
        onClick={() => {
          navigate('/login');
        }}
      >
        Login
      </WButton>
      <WIconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => setIsSnackbarVisible(false)}
      >
        <CloseIcon fontSize="small" />
      </WIconButton>
    </React.Fragment>
  );

  useEffect(() => {
    setLoading(true);

    dbService
      .getArticles({
        filter: { _id: article_id },
        relation: ['publisher', 'channel.category'],
      })
      .then((res) => {
        setArticle(res[0]);
        if (res[0]) {
          document.title = res[0].title!;
          const channel = res[0].channel as unknown as TChannel;
          const category = channel?.category as TCategory;
          const isDoc = category?.title === 'Documentation';
          setHideInteractions(isDoc);
          setIsDocumentation(isDoc);
        }
      })
      .finally(() => setLoading(false));
  }, [article_id]);

  const handleDeleteArticle = (id: string) => {
    deleteArticle(id);
  };

  return (
    <div className={styles['container']}>
      <div className={styles.content}>
        {!loading && article ? (
          <WArticle data={article} type={'content'} onDelete={handleDeleteArticle} hideInteractions={hideInteractions} />
        ) : (
          <WStack spacing={1.5} padding={'1.25rem'} justifyContent={'center'}>
            <WStack direction={'row'} alignItems={'center'} width={686} gap={0.75}>
              <WSkeleton animation="wave" variant="circular" width={40} height={40} />
              <WStack direction={'column'} alignItems={'start'}>
                <WSkeleton animation="wave" variant="text" width={160} height={22} />
                <WSkeleton animation="wave" variant="text" width={150} height={20} />
              </WStack>
            </WStack>
            <WStack direction={'column'} gap={2} paddingTop={1}>
              <WSkeleton animation="wave" variant="text" width={300} height={40} />
              <WSkeleton animation="wave" variant="rounded" width={'auto'} height={350} />
            </WStack>
            <WSkeleton animation="wave" variant="rounded" height={40} />
          </WStack>
        )}
      </div>
      {article && isDocumentation && (
        <div className={styles.sidebar}>
          <ArticleContentSidebar article={article} isDocumentation={isDocumentation} />
        </div>
      )}
      <WSnackbar
        open={isSnackbarVisible}
        autoHideDuration={3000}
        onClose={() => setIsSnackbarVisible(false)}
        message="In order to carry out this action, it is necessary to log in first."
        action={action}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      />
    </div>
  );
}
